<template>
    <div>
        <FixedNavbar v-show="displayFixedNavbar"/>

        <div class="container-fluid" :style="getBackgroundColor">
            <div class="row min-vh-100">
                <div class="col-12 col-md-10 col-xl-8 offset-md-1 offset-xl-2 d-flex flex-column">
                    <div class="d-flex flex-column flex-lg-row mt-5 mb-4 mb-lg-6 mt-lg-6" v-observe-visibility="observeNavigation">
                        <div
                                v-for="(route, index) in routes"
                                :key="index"
                                :class="['d-flex', {'flex-fill': route === currentRoute, 'justify-content-lg-center': index > 0 && index < routes.length - 1, 'justify-content-lg-end': index === routes.length - 1, 'mr-3 mr-lg-5': index < routes.length - 1}]">
                            <RuleLink :number="index+1" :url="route" v-if="currentRoute !== route" :class="[{'mb-2 mb-lg-0': index < routes.length-1}]"/>
                            <ActiveRuleLink :number="index+1" :url="route" v-if="currentRoute === route" :class="[{'mb-2 mb-lg-0': index < routes.length-1}]"/>
                        </div>
                    </div>

                    <div class="d-flex flex-column flex-fill justify-content-center mb-6">
                        <div class="row">
                            <div class="col-12">
                                <h1 :class="['title', {'extra-big': extraBig}]" v-html="title"></h1>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <a href="#" @click.prevent="scrollDown" class="read-more" aria-label="Preberi več o tej spletni prevari">Preberi več</a>
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col-12 arrow">
                                <Arrow></Arrow>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Arrow from '@/svg/arrow.vue'
	import FixedNavbar from '@/components/FixedNavbar.vue'
	import ActiveRuleLink from "./rule-links/ActiveRuleLink";
	import RuleLink from '@/components/rule-links/RuleLink.vue'
    import $ from 'jquery'

	export default {
		name: 'Title',
		components: {
			ActiveRuleLink,
			FixedNavbar,
			Arrow,
			RuleLink,
		},
		props: {
			title: {
				type: String,
				required: true,
			},
			background: {
				type: String,
				required: false,
				default: "rgba(173, 223, 222, 0.7)",
			},
            extraBig: {
				type: Boolean,
                required: false,
                default: false,
            },
		},
		data() {
			return {
				displayFixedNavbar: false,
				routes: [
					`/${process.env.VUE_APP_FIRST_RULE_URL}`,
					`/${process.env.VUE_APP_SECOND_RULE_URL}`,
					`/${process.env.VUE_APP_THIRD_RULE_URL}`,
				],
				currentRoute: this.$route.path,
			}
		},
		computed: {
			getBackgroundColor() {
				return `background-color: ${this.background}`;
			},
		},
		methods: {
			observeNavigation(isVisible) {
				this.displayFixedNavbar = !isVisible;
			},
            scrollDown() {
				$("html, body").animate({
                    scrollTop: $(window).innerHeight(),
                }, 250);
            },
		},
	}
</script>

<style lang="scss" scoped>
    .read-more {
        color: black;
        text-transform: uppercase;
        text-decoration: none;
        font-size: .75rem;
        font-weight: bold;
    }

    .arrow {
        svg {
            height: 30px;
        }

        animation: slide-down 1.5s ease-in-out 1s infinite;
        opacity: 0;

        @keyframes slide-down {
            0% {
                opacity: 0;
                transform: translateY(-35%);
            }
            25% {
                opacity: 1;
                transform: translateY(0%);
            }
            50% {
                opacity: 1;
                transform: translateY(0%);
            }
            75% {
                opacity: 0;
                transform: translateY(35%);
            }
        }
    }
</style>